<div class="all-page-combo-layout">
  <div class="all-page-feed">
    <div class="hpanel">
      <div class="panel-body border-radius-top-left-right-6">
        <div class="comNavBar bgCol">
          <div class="nav-iteam-1">
            <h6 class="fw-bold" for="">Invite Sent: {{ inviteLength }}</h6>
          </div>
          <div class="nav-iteam-2">
            <input #inviteSearchText type="text" class="form-control search-field-pad" placeholder="Search Invites "
              aria-label="Amount (to the nearest dollar)" name="searchadmin" id="searchadmin" [(ngModel)]="searchKey"
              (input)="onSearchInvite(inviteSearchText.value)" />

          </div>
          <div class="nav-iteam-3">
            <div class="btn-group" dropdown>
              <button id="button-basic" dropdownToggle type="button" class="btn btn-primary dropdown-toggle hgop"
                aria-controls="dropdown-basic"  style="border-radius: 8px !important; height: 32px !important;">
                All
                <ng-icon name="tablerFilter"></ng-icon>
              </button>
              <!-- <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
              </ul> -->
            </div>
          </div>
          <div class="nav-iteam-4">

          </div>

        </div>
      </div>
    </div>
    <div class="margin-top-5">
      <ng-container *ngIf="loadAPIcall && !loadScroll">
        <div class="col-md-6 col-lg-4 col-sm-12 padding-left-0 padding-right-5"
          *ngFor="let n of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
          <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
        </div>
      </ng-container>

      <div *ngIf="membersData?.length > 0" infiniteScroll [alwaysCallback]="true"
        [infiniteScrollDistance]="5" [infiniteScrollThrottle]="300" (scrolled)="onScrollDown()">
        <div class="col-md-6 col-lg-4 col-sm-12 padding-left-0 padding-right-5 mr-tp-5"
          *ngFor="let data of membersData">
          <app-user-card [userDataInput]="data" [labelName]="'TEAM'" [config]="userCardConfig"
            [button]="'PRIMARY'" [standard]="true"></app-user-card>
        </div>

        <ng-container *ngIf="loadScroll">
          <div class="col-md-6 col-lg-4 col-sm-12 padding-left-0 padding-right-5" *ngFor="let n of [1, 2, 3]">
            <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
          </div>
        </ng-container>
      </div>

      <div class="col-md-12 pad"
        *ngIf="membersData?.length === 0 && !loadAPIcall && invitePayload.searchContent">
        <app-nodata-found
          screen="SEARCH"
          [title]="['No results found', 'Try adjusting your search']"
          [buttonShow]="false">
        </app-nodata-found>
      </div>

      <div class="col-md-12 pad" *ngIf="membersData?.length === 0 && !loadAPIcall && !invitePayload.searchContent">
        <app-nodata-found [title]="noDatafound"></app-nodata-found>
      </div>

    </div>
  </div>
  <div class="all-page-widget">
    <app-common-widget [page]="'TEAMS_MEMBER_PAGE'" [inputData]="'TEAM'"></app-common-widget>
  </div>
</div>